import React, { useMemo } from 'react';
import { TextField, Typography } from '@fdha/web-ui-library';
import { Stack } from '@mui/material';
import { AppointmentTypeCategory } from '@fdha/graphql-api-admin';

interface CalendarConfigInputsProps {
  calendarIdValue?: string | null;
  calendarIdName: string;
  appointmentTypeName: string;
  appointmentTypeCategories: AppointmentTypeCategory[];
  handleBlur: (event: React.FocusEvent<HTMLInputElement>) => void;
  disabled?: boolean;
  onChange: (name: string, value: string) => void;
}

const CalendarConfigInputs: React.FC<CalendarConfigInputsProps> = ({
  calendarIdValue,
  calendarIdName,
  appointmentTypeCategories,
  appointmentTypeName,
  handleBlur,
  disabled,
  onChange,
}) => {
  const formattedCategories = useMemo(() => {
    return (
      appointmentTypeCategories?.map((category) => {
        const isForeignLanguage = category.language !== 'English';

        const name = isForeignLanguage
          ? `${category.name} (${category.language})`
          : category.name;

        const description = isForeignLanguage
          ? `${category.description} Use it to send Acuity emails in ${category.language}.`
          : category.description;

        return {
          ...category,
          name,
          description,
        };
      }) || []
    );
  }, [appointmentTypeCategories]);

  return (
    <Stack direction="column" spacing={0.5}>
      <TextField
        title="Calendar ID"
        name={calendarIdName}
        helperText="You can find your numeric Calendar ID at the end of the URL when editing your Calendar settings."
        onChange={(event) => {
          const { name, value } = event.target;
          onChange(name, value);
        }}
        onBlur={handleBlur}
        value={calendarIdValue ?? ''}
        disabled={disabled}
        onlyNumbers
      />
      {appointmentTypeCategories?.length &&
        formattedCategories.map((category, index) => (
          <Stack key={category.id} spacing={0.5}>
            <Typography variant="subtitle2">{category.name}</Typography>
            <TextField
              name={`${appointmentTypeName}[${index}].appointmentTypeId`}
              helperText={category.description}
              onChange={(event) => {
                const { name, value } = event.target;
                onChange(name, value);
              }}
              onBlur={handleBlur}
              value={category.appointmentTypeId ?? ''}
              disabled={disabled}
              onlyNumbers
            />
          </Stack>
        ))}
    </Stack>
  );
};

export default CalendarConfigInputs;
